import _ from 'lodash';

const initialState = {
	ssoRegistrationParams: null,
	geAccountNumbers: [],
	showAddressVerificationDialog: false,
	addressVerificationData: null,
	isAnyValidAccountNumber: null,
	isAlreadyApprovedOrPending: null,
};

export default function registration(state = initialState, action) {
    switch (action.type) {
	    case 'SAVE_SSO_REGISTRATION':
	        return { ...state,
	            ssoRegistrationParams: action.data
	        };
		case 'SHOW_ADDRESS_VERIFICATION_DIALOG':
	        return { ...state,
	            showAddressVerificationDialog: action.data
	        };
		case 'SAVE_ADDRESS_VERIFICATION':
			return { ...state,
				addressVerificationData: action.data
			};
		case 'SAVE_IS_ANY_VALID_ACCOUNT_NUMBER':
			return { ...state,
				isAnyValidAccountNumber: action.data
			};
		case 'SAVE_IS_ALREADY_APPROVED_OR_REJECT':
			return { ...state,
				isAlreadyApprovedOrPending: action.data
			};
		case 'RESET_GE_CUSTNET_ACCOUNT_NUMBERS':
			var accountNumbers = [];
			for(var i=0;i<20;i++) accountNumbers.push({ accountNumber: '', valid: null, accountName: '' });
			return { ...state,
				geAccountNumbers: accountNumbers
			}
		case 'SAVE_GE_CUSTNET_ACCOUNT_NUMBERS':
			accountNumbers = state.geAccountNumbers;
			accountNumbers[action.data.index-1].accountNumber = action.data.value;
			accountNumbers[action.data.index-1].valid = action.data.valid;
			accountNumbers[action.data.index-1].accountName = action.data.accountName;
			accountNumbers[action.data.index-1].showLoader = action.data.showLoader;
			accountNumbers[action.data.index-1].isAlreadyApproved = action.data.isAlreadyApproved;
			accountNumbers[action.data.index-1].isAlreadyPending = action.data.isAlreadyPending;
			accountNumbers[action.data.index-1].isOnlyGEAPartsSalesAgreementsAccount = action.data.isOnlyGEAPartsSalesAgreementsAccount;
			accountNumbers[action.data.index-1].companyName = action.data.companyName;
			accountNumbers[action.data.index-1].userRole = action.data.userRole;
			accountNumbers[action.data.index-1].isCheckedForSalesAgreements = action.data.isCheckedForSalesAgreements;

			return { ...state,
				geAccountNumbers: accountNumbers
			}
		case 'ENABLE_DISABLE_BUTTON':
			return { ...state,
				updateButton: action.data
			};
		case 'RESET_REGISTRATION_REDUCERS':
			return initialState;
	    default:
	        return state;
    }
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/registration.js